import React from "react";
import { Button, MetadataField } from "../atoms";
import { ViewModeSwitcher } from "../molecules";

function SessionHeader({
  onBack,
  metadata = {},
  fps = 0,
  frames = 0,
  currentFrame = 0,
  currentTimeMs = 0,
  viewMode = "horizontal",
  onViewModeChange = () => {},
  translate = (key) => key,
  className = "",
}) {
  const resolveLabel = (key, fallback) => {
    const val = translate(key);
    return val && val !== key ? val : fallback;
  };

  const fields = [
    {
      label: resolveLabel("prueba", resolveLabel("tipo_prueba", "Prueba:")),
      value: metadata.tipoPrueba,
    },
    { label: translate("grupo_"), value: String(metadata.group ?? "") },
    { label: translate("nombre:_"), value: metadata.name },
    { label: translate("apellido_"), value: metadata.surname },
    { label: translate("fecha"), value: metadata.date },
  ];

  const fieldClassName =
    "shrink-0 h-14 justify-center py-1 text-xs leading-tight";

  return (
    <header
      className={`flex flex-row flex-nowrap items-center h-14 max-h-14 overflow-x-auto overflow-y-hidden gap-x-2 px-4 py-0 bg-surface border-b border-secondary-faded ${className}`}
    >
      <div className="flex flex-row flex-nowrap items-center gap-2 shrink-0">
        <Button
          variant="ghost"
          className="!min-w-0 shrink-0"
          icon="arrow-left"
          title={translate("volver")}
          onClick={onBack}
        >
          {translate("volver")}
        </Button>
        <div className="flex flex-row flex-nowrap items-center gap-x-4 shrink-0 border-l border-secondary-faded pl-4">
          {fields.map((field) => (
            <MetadataField
              key={field.label}
              label={field.label}
              value={field.value}
              className={fieldClassName}
            />
          ))}
        </div>
      </div>
      <div className="flex flex-row flex-nowrap items-center gap-x-4 shrink-0 ml-auto">
        {viewMode === "vertical" ? (
          <div className="flex flex-row flex-nowrap items-center gap-x-4 shrink-0">
            <MetadataField
              variant="text"
              label={String(translate("frame")).trim()}
              value={currentFrame}
              className={fieldClassName}
              valueClassName="!text-brand-accent-fg"
            />
            <MetadataField
              variant="text"
              label={String(translate("tiempo_ms_")).trim()}
              value={currentTimeMs}
              className={fieldClassName}
              valueClassName="!text-brand-accent-fg"
            />
          </div>
        ) : null}
        <div className="flex flex-row flex-nowrap items-center gap-x-4 shrink-0 border-l border-secondary-faded pl-4">
          <MetadataField
            label={translate("frames_totales")}
            value={frames}
            className={fieldClassName}
          />
          <MetadataField
            label={translate("fps")}
            value={fps}
            className={fieldClassName}
          />
        </div>
        <div className="flex flex-row flex-nowrap items-center gap-x-3 shrink-0 border-l border-secondary-faded pl-4">
          <ViewModeSwitcher mode={viewMode} onChange={onViewModeChange} />
        </div>
      </div>
    </header>
  );
}

export default SessionHeader;